/**
 * 统一文案视图 - 整合 Bullet Point + FABE + 关键词覆盖
 */

import React from 'react';
import { Typography, Segmented } from 'antd';
import { SEOAnalysisPanel } from './SEOAnalysisPanel';
import type { GenerateCopyResult } from '../../types';
import { useUnifiedCopyView } from './hooks/useUnifiedCopyView';
import { TitleSection } from './UnifiedCopyViewComponents/TitleSection';
import { KeywordSummary } from './UnifiedCopyViewComponents/KeywordSummary';
import { SellingPointCard } from './UnifiedCopyViewComponents/SellingPointCard';

const { Title } = Typography;

interface UnifiedCopyViewProps {
    result: GenerateCopyResult;
    keywords?: string[];  // 关键词列表用于SEO分析
    onRegenerateFABE?: (sellingPoint: string) => Promise<void>;
    regeneratingFABE?: string | null;
}

export const UnifiedCopyView: React.FC<UnifiedCopyViewProps> = ({
    result,
    keywords = [],
    onRegenerateFABE,
    regeneratingFABE,
}) => {
    const {
        activeSite,
        setActiveSite,
        availableSites,
        bulletPoints,
        coverage,
        copyToClipboard,
    } = useUnifiedCopyView({ result });

    return (
        <div>
            {/* 站点选择器 */}
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={5} style={{ margin: 0 }}>📝 生成结果</Title>
                <Segmented
                    options={availableSites}
                    value={activeSite}
                    onChange={v => setActiveSite(v as string)}
                />
            </div>

            {/* 关键词覆盖统计 */}
            <KeywordSummary coverage={coverage} />

            {/* SEO优化分析 */}
            {keywords.length > 0 && (
                <SEOAnalysisPanel
                    title={result.titles[activeSite] || ''}
                    bulletPoints={bulletPoints}
                    keywords={keywords}
                />
            )}

            {/* 标题 */}
            <TitleSection result={result} activeSite={activeSite} />

            {/* 卖点列表 (整合BP + FABE) */}
            {result.fabe_analysis.map((fabe, index) => (
                <SellingPointCard
                    key={index}
                    fabe={fabe}
                    index={index}
                    bulletPoint={bulletPoints[index] || ''}
                    activeSite={activeSite}
                    regeneratingFABE={regeneratingFABE}
                    onRegenerateFABE={onRegenerateFABE}
                    copyToClipboard={copyToClipboard}
                />
            ))}
        </div>
    );
};

export default UnifiedCopyView;
